import { AutomationSetting, AutomationSettingValues } from '@maximizer/actions/domain';
import { isSendAt } from './send-at';

export function isKnownSetting(setting: AutomationSetting): boolean {
  if (setting.type === 'select') return Array.isArray(setting.options);
  return setting.type === 'time';
}

function isValid(setting: AutomationSetting, value: string | undefined): value is string {
  if (value === undefined) return false;
  return setting.type === 'time' ? isSendAt(value) : setting.options.some((option) => option.value === value);
}

export function effectiveSettings(settings: readonly AutomationSetting[], stored: AutomationSettingValues): AutomationSettingValues {
  return Object.fromEntries(
    settings.filter(isKnownSetting).map((setting) => {
      const value = stored[setting.name];
      return [setting.name, isValid(setting, value) ? value : setting.defaultValue];
    }),
  );
}
